import axiosInstance from "@/services/http/axios-instance";

export class CartApi {
  addPaymentToCart(paymentData) {
    return axiosInstance.post("/cart/add", {
      ...paymentData,
    });
  }

  loadCart() {
    return axiosInstance.get("/cart");
  }

  deleteCartItem(cartItemId) {
    return axiosInstance.post("/cart/item/delete", {
      cart_item_id: cartItemId,
    });
  }

  getCartItemsCount() {
    return axiosInstance.get("/cart/items/count");
  }

  loadLastClient() {
    return axiosInstance.get("/cart/client/last");
  }

  updateCartItemCount(cartItemId, cartItemCount) {
    return axiosInstance.post("/cart/items/count", {
      cart_item_id: cartItemId,
      new_count: cartItemCount,
    });
  }
}
